export default __webpack_public_path__ + "static/media/format-painter.d585f662.svg";